// shell-sdk/src/constants.js

export const SDK_VERSION = "1.0.0";
export const PROTOCOL_VERSION = 1;
export const DEFAULT_TIMEOUT_MS = 10000;

export const EVENT_TYPES = {
    SHELL_READY: "shell.ready",
    SHELL_CONTEXT: "shell.context",
    SHELL_CONFIG: "shell.config",
    SHELL_ROUTE_CHANGED: "shell.routeChanged",
    SHELL_CAPABILITIES_CHANGED: "shell.capabilitiesChanged",

    MFE_LIFECYCLE_READY: "mfe.lifecycle.ready",
    MFE_ERROR_REPORT: "mfe.error.report",
    MFE_ROUTE_CHANGED: "mfe.route.changed",
    MFE_ANALYTICS_TRACK: "mfe.analytics.track",

    PLATFORM_NAVIGATION_EXECUTE: "platform.navigation.execute",
    PLATFORM_NAVIGATION_BACK: "platform.navigation.back",
    PLATFORM_NAVIGATION_CLOSE: "platform.navigation.close",
    PLATFORM_NAVIGATION_OPEN_EXTERNAL: "platform.navigation.openExternal",
    PLATFORM_NAVIGATION_OPEN_NATIVE: "platform.navigation.openNative",
    PLATFORM_HTTP_REQUEST: "platform.http.request",
};

export const CAPABILITIES = {
    NAVIGATION: "navigation",
    HTTP: "http",
    ANALYTICS: "analytics",
    STORAGE: "storage",
    EVENTS: "events",
    CLOSE: "close",
    EXTERNAL_NAVIGATION: "externalNavigation",
    NATIVE_NAVIGATION: "nativeNavigation",
};

export const ERROR_CATEGORIES = {
    CAPABILITY: "capability",
    POLICY: "policy",
    AUTH: "auth",
    NETWORK: "network",
    BACKEND: "backend",
    TIMEOUT: "timeout",
    UNSUPPORTED: "unsupported",
    UNKNOWN: "unknown",
};
